<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
import chartResize from "./mixins/chart-resize";
import { loopShowTooltip } from "@/utils/gl_echarts_tooltip_auto_show.js";
export default {
  name: 'LineEchartsHegu',
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: true,
    },
    xAxisName: {
      type: String,
      default: "",
    },
    yAxisName: {
      type: String,
      default: "人",
    },
    colorDic: {
      type: Object,
      default: () => {
        return {
          axisLineColor: "rgba(43, 189, 225, 0.3)", //坐标轴颜色
          axisLabelColor: "rgba(133, 139, 146, 1)", //坐标轴字体颜色
          fillColor: [
            "rgba(10, 246, 68, 0.1)",
            "rgba(10, 246, 68, 0.4)",
          ],
          lineColor: "#0AF644"
        };
      }
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    tooltipMap(myChart, option) {
      console.log("播放折线图数据")
      this.tootipTimer && this.tootipTimer.clearLoop();
      this.tootipTimer = 0;
      // 调用轮播的方法
      // myChart为Echarts容器实例
      this.tootipTimer = loopShowTooltip(myChart, option, {
        interval: 2000, // 轮播间隔时间
        loopSeries: true // 是否开启轮播循环
        // shunXu: "daoXu", // 显示顺序
        // loopSeries: boolean类型，默认为false。true表示循环所有series的tooltip；false则显示指定seriesIndex的tooltip。
        // seriesIndex: 默认为0，指定某个系列（option中的series索引）循环显示tooltip，当loopSeries为true时，从seriesIndex系列开始执行。
      });
    },
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions();
    },
    setOptions() {
      var that = this
      this.chart.setOption({
        tooltip: {
        trigger: "axis",
        axisPointer: { 
          type: "line",
          snap: true,
          lineStyle: {
            type: "dashed",
            color:this.colorDic.lineColor
          },
          // label: {
          //   show: true,
          //   fontSize:'85%',
          //   backgroundColor:'rgba(13, 81, 122, 0.8)',
          //   // color:this.colorDic.lineColor,
          //   formatter: function(params) {
          //     return params.value;
          //   }
          // },
          // handle: {
          //   show: true
          // },
        },
        textStyle: {
          color: '#010F38',
          fontStyle: "normal",
          fontWeight: "bold",
          fontFamily: "PingFang SC",
          fontSize:'72%'
        },
        borderColor:'transparent',
        backgroundColor: 'transparent',
          formatter: (params) => {
            let {value, color} = params[0]
            var htmlText = `<div style="background:${color} !important;border-radius:5px;padding:0 4px;">${value}</div>`
            return htmlText
          },
        },
        grid: {
          top: '5%',
          left: "5%",
          right: "5%",
          bottom: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false, // 不留白，从原点开始
            name: this.xAxisName,
            nameTextStyle: {
              color: "#c0c3cd",
              fontSize: 10,
            },
            data: this.chartData.days,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#205189",
              },
            },
            axisLabel: {
              color: "#c0c3cd",
              fontSize: 10,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: this.yAxisName,
            nameTextStyle: {
              color: "#c0c3cd",
              padding: [0, 24, 0, 0],
              fontSize: 10,
            },
            axisLabel: {
              color: "#c0c3cd",
              fontSize: 10,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#205189",
              },
            },
            splitLine: {
              lineStyle: {
                type: "solid",
                color: "rgba(43, 189, 225, 0.3)",
              },
            },
          },
        ],
        series: [
          {
            type: "line",
            smooth: true,
            data: this.chartData.data,
            symbol: "circle",
            symbolSize: 4,
            showSymbol: true,
            lineStyle: {
              normal: {
                color: this.colorDic.lineColor, // '#34cbf6',
              },
            },
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: this.colorDic.fillColor[0] // '#082fa2', // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: this.colorDic.fillColor[1] // 'rgba(8,47,162,.3)',
                    },
                    {
                      offset: 1,
                      color: "transparent" // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                }
              }
            },
            itemStyle: {
              color: this.colorDic.lineColor, // '#34cbf6',
              shadowBlur: 5,
              shadowColor: "#fff",
            },
            // markPoint: {
            //   symbol:
            //     'image://' +
            //     'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAjCAMAAAD1/jdcAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAALFQTFRFAAAA661F661F661F661F661F661F661F661F661F661F661F661F661F7bNR8Lxi8b5m8b9n661F661F661F8b5l661F661F661F661F8b5m8b9m7bNR661F7LFM661F661F661F7bRS8b5m8L1k7LBK661F661F661F661F661F661F7rVT8L1k7LBL661F661F661F661F7rZV8L1k7LFN661F661F661F661F661FvQ/oBwAAADt0Uk5TAAIHDBIVFgQcLTk/QSNbzvb/Bg0s7jgRPhT391obTSJDS3/45mVJQgMXHTFz5FUrARAoZNJHDhkeCwVXmKGrAAAA40lEQVR4nO3WxxKCMBAG4IWlg8QgRQTE3nvX938wE73KOJN48MB/znzZ0/4LAIqKmm6IRddQVYDFRMt2XE8srmNbaLJJsOGTJhVNk/gNVEC1fHHj5fhWAC2bSCGUkhBBc+RGoTSKE9BdSYTSdgqGJ614Rq3USq3Uyp8rP9iYbsq2d0cS4dv7N03CWi2TQrK8CHjD5iQSNiLSLVnD8rYP449t3+sPhuzhaDyZVrZ9HBY440eDElRcHvPFcpXR9WZbVF8eCQavy6M6O3N/OJ7O5fsz4ezMy/Vm3OUQxswe6uPLxDxPYLiMPmJuVccAAAAASUVORK5CYII',
            //   symbolSize: [53, 31],
            //   symbolOffset: [0, -22],
            //   symbolKeepAspect: true,// 如果 symbol 是 path:// 的形式，是否在缩放时保持该图形的长宽比。
            //   data: [{ type: "max", name: "最大值" }],
            //   // symbolSize: function(value) {
            //   //   let length = value.toString().length;
            //   //   return length < 2 ? 20 : length * 10;
            //   // },

            //   animationDelay: 3000,
            //   animationDuration: 1000,
            //   label: {
            //     fontSize: "16",
            //     fontWeight: "bold",
            //     //backgroundColor: {image: 'xxx/xxx.png'}
            //     color: "#010F38",
            //   }
            // },
          },
        ],
      });
       //tooltip 轮播
      this.tooltipMap(this.chart, this.chart.getOption());
    },
    textSize(text,fontSize) {
        var span = document.createElement("span");
        var result = {
            "width": span.offsetWidth,
            "height": span.offsetHeight
        };
        span.style.visibility = "hidden";
        span.style.fontSize = fontSize || "14px";
        document.body.appendChild(span);

        if (typeof span.textContent != "undefined")
            span.textContent = text || "国";
        else span.innerText = text || "国";

        result.width = span.offsetWidth - result.width;
        result.height = span.offsetHeight - result.height;
        span.parentNode.removeChild(span);
        return result;
    },
    toHSpeed(speed,fix) {
        if(isNaN(speed))
            return speed;
        if(!fix&&fix!=0)
            fix=2;
        if(speed>=125000000)
        {
            speed/=125000000;
            speed=speed.toFixed(fix)+"Gbps"
        }
        else if(speed>=125000)
        {
            speed/=125000;
            speed=speed.toFixed(fix)+"Mbps"
        }
        else if(speed>=125)
        {
            speed/=125;
            speed=speed.toFixed(fix)+"Kbps"
        }
        else
        {
            speed*=8;
            speed=speed.toFixed(fix)+"bps"
        }
        return speed
    }
  },
};
</script>
